import React, { lazy } from 'react';
import { ProtectedRoute } from '@components';

const Submitted = lazy(() => import('./submitted'));

export default {
  path: 'submitted',
  element: <ProtectedRoute title="申请已提交" component={<Submitted />} />,
};
